import { render, staticRenderFns } from "./Policia.vue?vue&type=template&id=45c61b6f&scoped=true"
import script from "./Policia.vue?vue&type=script&lang=js"
export * from "./Policia.vue?vue&type=script&lang=js"
import style0 from "./Policia.vue?vue&type=style&index=0&id=45c61b6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c61b6f",
  null
  
)

export default component.exports